import * as THREE from 'three';
import type { StepRegistry } from '../StepRegistry';
import { wait } from './utils';

function resolveCoords(params: { coordinates: [number, number]; infraId?: string }, systems: any): [number, number] {
  if (params.infraId && systems.city) {
    const pos = systems.city.getInfraPosition(params.infraId);
    if (pos) return pos;
  }
  return params.coordinates;
}

export function registerEffectSteps(registry: StepRegistry): void {
  registry.register('activate-sensor', async (step, systems) => {
    const coords = resolveCoords(step.params, systems);
    const { color } = step.params;
    systems.effects.addSensorPulse('sensor', coords, color);
    // Sensor ripple stays active until model-status replaces it or scenario ends
  });

  registry.register('model-status', async (step, systems) => {
    // Remove sensor ripple — model-status takes over
    systems.effects.removeSensorPulse('sensor');

    const coords = resolveCoords(step.params, systems);
    const { color, emissive } = step.params;
    const threeColor = new THREE.Color(color);
    systems.models.setModelEmissive(coords, threeColor, emissive ?? 2.0);
    systems.effects.addStatusRing('model-status', coords, color);

    await wait(step.duration);
    systems.models.resetModelEmissive(coords);
    systems.effects.removeStatusRing('model-status');
  });
}
